import api from './api';

const STORAGE_KEY = 'referralAttribution';
const REFERRAL_WINDOW_MS = 90 * 24 * 60 * 60 * 1000;

export const storeReferralToken = (token) => {
  if (!token) return;

  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    token,
    storedAt: Date.now()
  }));
};

export const getStoredReferralToken = () => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    if (!parsed?.token || !parsed?.storedAt) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    if ((Date.now() - parsed.storedAt) > REFERRAL_WINDOW_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return parsed.token;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

export const clearStoredReferralToken = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const getReferralSummary = async () => {
  const response = await api.get('/Referral/me');
  return response.data;
};

